// TIND cart drawer — opens/closes via custom events, re-renders body
// from /cart.js fetches. Listens for legacy `ajaxProduct:added` event
// dispatched by add-to-cart actions across the theme + bundle blocks.

(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, '{{amount}} kr');
    }
    return ((cents | 0) / 100).toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr';
  }

  function cartHasDiscount(state) {
    if (!state) return false;
    if ((state.total_discount | 0) > 0) return true;
    if ((state.cart_level_discount_applications || []).length) return true;
    return (state.items || []).some(function (it) {
      return (it.line_level_discount_allocations || []).length > 0;
    });
  }

  // A bundle id looks like an opaque id (GUID/hash), not a boolean/short flag.
  function looksLikeBundleId(v) {
    v = String(v);
    if (v.length < 6) return false;
    return !/^(true|false|yes|no|0|1)$/i.test(v);
  }

  // Group cart line items that belong to the same bundle (e.g. a FastBundle kit).
  // Bundle apps tie their lines together with a SHARED line-item property whose
  // key is bundle-related or hidden (`_`-prefixed) and whose value is a unique
  // bundle id repeated across every line of that bundle. Returns:
  //   { groupOf: { <itemIndex>: <groupId> }, keysByGroup: { <groupId>: [lineKeys] } }
  // Empty when nothing groups — so non-bundle carts behave exactly as before.
  function computeBundleGroups(items) {
    var sigToIdx = {};
    items.forEach(function (it, i) {
      var props = (it && it.properties) || {};
      Object.keys(props).forEach(function (k) {
        var bundleish = /bundle|_rb|_fb|group/i.test(k);
        var hidden = k.charAt(0) === '_';
        if (!bundleish && !hidden) return;
        var v = props[k];
        if (v == null || v === '') return;
        if (!bundleish && !looksLikeBundleId(v)) return;
        var sig = k + ' ' + v;
        (sigToIdx[sig] = sigToIdx[sig] || []).push(i);
      });
    });

    var groupOf = {};
    var keysByGroup = {};
    var n = 0;
    Object.keys(sigToIdx).forEach(function (sig) {
      var idxs = sigToIdx[sig];
      if (idxs.length < 2) return; // a bundle spans 2+ lines
      var gid = null;
      idxs.forEach(function (i) { if (groupOf[i] != null) gid = groupOf[i]; });
      if (gid == null) gid = 'b' + (n++);
      idxs.forEach(function (i) {
        if (groupOf[i] == null) {
          groupOf[i] = gid;
          (keysByGroup[gid] = keysByGroup[gid] || []).push(items[i].key);
        }
      });
    });
    return { groupOf: groupOf, keysByGroup: keysByGroup };
  }

  // Observe cart-write requests at the network layer as early as possible —
  // before third-party cart scripts (e.g. FastBundle) wrap fetch/XHR — so we
  // sit closest to the network and catch their cart writes too. Each successful
  // write dispatches 'tind:cart-mutated' (detail.opened === true for /cart/add),
  // which init() turns into a drawer refresh (+ open on add).
  (function monitorCartMutations() {
    var ADD_RE = /\/cart\/add(\.js)?($|[?#])/;
    var WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?($|[?#])/;

    function signal(url) {
      if (!url || !WRITE_RE.test(url)) return;
      document.dispatchEvent(new CustomEvent('tind:cart-mutated', {
        detail: { opened: ADD_RE.test(url) }
      }));
    }

    if (typeof window.fetch === 'function') {
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        return nativeFetch.apply(this, arguments).then(function (resp) {
          try { if (resp && resp.ok) signal(url); } catch (e) {}
          return resp;
        });
      };
    }

    try {
      var xhrOpen = XMLHttpRequest.prototype.open;
      var xhrSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__tindCartUrl = url;
        return xhrOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        xhr.addEventListener('load', function () {
          try { if (xhr.status >= 200 && xhr.status < 300) signal(xhr.__tindCartUrl || ''); } catch (e) {}
        });
        return xhrSend.apply(this, arguments);
      };
    } catch (e) {}
  })();

  function init() {
    var drawer = $('[data-tind-cart-drawer]');
    if (!drawer) return;

    var body = $('[data-tind-cart-body]', drawer);
    var itemsEl = $('[data-tind-cart-items]', drawer);
    var emptyEl = $('[data-tind-cart-empty]', drawer);
    var footEl = $('[data-tind-cart-foot]', drawer);
    var subtotalEl = $('[data-tind-cart-subtotal]', drawer);
    var totalEl = $('[data-tind-cart-total]', drawer);
    var countEl = $('[data-tind-cart-count]', drawer);
    var discountsEl = $('[data-tind-cart-discounts]', drawer);
    var shipBar = $('[data-tind-cart-shipbar]', drawer);
    var shipBarText = $('[data-tind-cart-shipbar-text]', drawer);
    var shipBarFill = $('[data-tind-cart-shipbar-fill]', drawer);

    var freeShippingEnabled = drawer.dataset.freeShippingEnabled === 'true';
    var freeShippingThreshold = parseInt(drawer.dataset.freeShippingThreshold, 10) || 0;
    var progressTextTpl = drawer.dataset.freeShippingProgressText || 'Du er {{remaining}} unna gratis frakt';
    var unlockedText = drawer.dataset.freeShippingUnlockedText || 'Du har gratis frakt!';

    // The theme drawer is used when the Tind Bundles app embed says so
    // (window.TindCart.themeDrawer, set in <head> before this file runs).
    // Otherwise the store uses Kaching Cart: tind-cart.js still runs so the
    // header cart-count dot stays in sync, but open() is a no-op.
    var THEME_DRAWER_ENABLED = !!(window.TindCart && window.TindCart.themeDrawer === true);

    function open() {
      if (!THEME_DRAWER_ENABLED) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('cart:open', open);
    document.addEventListener('cart:close', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    $$('[data-tind-cart-close]', drawer).forEach(function (el) {
      el.addEventListener('click', close);
    });

    function renderItem(item, idx, groupKeys) {
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '';
      var imgSrc = item.image ? item.image.replace(/(\.[a-z]+)\?/, '_220x$1?') : '';
      var allocs = item.line_level_discount_allocations || [];
      var hasDiscount = allocs.length > 0;
      var line = idx + 1;

      var pricesHtml = hasDiscount
        ? '<span class="tind-cart-drawer__item-price tind-cart-drawer__item-price--final">' + formatMoney(item.final_line_price) + '</span>' +
          '<span class="tind-cart-drawer__item-price tind-cart-drawer__item-price--original">' + formatMoney(item.original_line_price) + '</span>'
        : '<span class="tind-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';

      var discountsHtml = '';
      if (hasDiscount) {
        discountsHtml = '<ul class="tind-cart-drawer__item-discounts">';
        allocs.forEach(function (a) {
          var name = (a.discount_application && a.discount_application.title) || '';
          discountsHtml +=
            '<li>' +
            '<span class="tind-cart-drawer__discount-badge">−' + formatMoney(a.amount) + '</span>' +
            '<span class="tind-cart-drawer__discount-name">' + escapeHtml(name) + '</span>' +
            '</li>';
        });
        discountsHtml += '</ul>';
      }

      // Bundle members get a single "remove whole kit" control and no per-line
      // quantity stepper (the kit is sold as a unit). Normal items keep the stepper.
      var controlsHtml = groupKeys
        ? '<div class="tind-cart-drawer__item-controls">' +
          '  <button type="button" class="tind-cart-drawer__remove" data-tind-cart-remove data-keys="' + escapeHtml(JSON.stringify(groupKeys)) + '" aria-label="Fjern">Fjern</button>' +
          '</div>'
        : '<div class="tind-cart-drawer__item-controls">' +
          '  <div class="tind-cart-drawer__qty">' +
          '    <button type="button" data-tind-cart-step="-1" data-line="' + line + '" aria-label="Minus">−</button>' +
          '    <span data-tind-cart-qty>' + item.quantity + '</span>' +
          '    <button type="button" data-tind-cart-step="1" data-line="' + line + '" aria-label="Pluss">+</button>' +
          '  </div>' +
          '  <button type="button" class="tind-cart-drawer__remove" data-tind-cart-remove data-line="' + line + '" aria-label="Fjern">Fjern</button>' +
          '</div>';

      // Subscription choice (Kaching Subscriptions selling plans). Filled in by
      // fillSubscription() once the product's plans are known; bundle, gift and
      // offer lines never get one.
      var subHtml = canSubscribe(item, groupKeys)
        ? '<div class="tind-cart-drawer__sub" data-tind-cart-sub hidden></div>'
        : '';

      var li = document.createElement('li');
      li.className = 'tind-cart-drawer__item';
      li.dataset.tindCartItem = '';
      li.dataset.line = String(line);
      li.dataset.key = item.key;
      li.dataset.variantId = String(item.variant_id);
      li.innerHTML =
        '<a href="' + item.url + '" class="tind-cart-drawer__item-media">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="" class="tind-cart-drawer__item-img" loading="lazy">' : '') +
        '</a>' +
        '<div class="tind-cart-drawer__item-meta">' +
        '  <a class="tind-cart-drawer__item-title" href="' + item.url + '">' + escapeHtml(item.product_title || item.title || '') + '</a>' +
        (variant ? '  <span class="tind-cart-drawer__item-variant">' + escapeHtml(variant) + '</span>' : '') +
        '  <div class="tind-cart-drawer__item-prices">' + pricesHtml + '</div>' +
        discountsHtml +
        controlsHtml +
        subHtml +
        '</div>';
      return li;
    }

    // ---- Subscriptions (selling plans) --------------------------------------

    // Tind's own bundle, gift and offer lines keep their terms.
    var TIND_LINE_PROP_RE = /^_tind_bundle|^_tind_gift_threshold$|^_tind_offer_id$/;
    function isTindPackageLine(item) {
      return Object.keys(item.properties || {}).some(function (k) { return TIND_LINE_PROP_RE.test(k); });
    }
    function hasLineDiscount(item) {
      return (item.line_level_discount_allocations || []).length > 0 ||
        item.final_line_price !== item.original_line_price;
    }
    // A subscription line always shows its plan, whatever other properties it
    // carries (every product-page add has Kaching Bundles' __kaching_bundles).
    // A one-time line is offered a subscription only when it is not already
    // discounted (a Kaching Duo stays a Duo), not free, and not grouped.
    function canSubscribe(item, groupKeys) {
      if (isTindPackageLine(item)) return false;
      if (item.selling_plan_allocation) return true;
      if (groupKeys) return false;
      if (!(item.final_line_price > 0)) return false;
      return !hasLineDiscount(item);
    }

    function productHandle(item) {
      if (item.handle) return item.handle;
      var m = /\/products\/([^/?#]+)/.exec(item.url || '');
      return m ? m[1] : '';
    }

    // Plans per product handle, fetched once while the page is open. Holds a
    // promise of { plans: [...], required: bool }, or null (no plans / failed).
    var planCache = {};
    function loadPlans(handle) {
      if (!planCache[handle]) {
        planCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var plans = [];
            ((p && p.selling_plan_groups) || []).forEach(function (g) {
              (g.selling_plans || []).forEach(function (sp) { plans.push(sp); });
            });
            return plans.length ? { plans: plans, required: !!p.requires_selling_plan } : null;
          })
          .catch(function () { return null; });
      }
      return planCache[handle];
    }

    // The percentage off on the recurring orders: the adjustment with no
    // order_count (it applies from then on), else the one at position 1.
    // 0 when it is not a percentage.
    function planPercent(plan) {
      var adjs = (plan && plan.price_adjustments) || [];
      var adj = null;
      adjs.forEach(function (a) { if (!adj && a.order_count == null) adj = a; });
      if (!adj) adjs.forEach(function (a) { if (!adj && a.position === 1) adj = a; });
      if (!adj) adj = adjs[0];
      return adj && adj.value_type === 'percentage' ? (adj.value || 0) : 0;
    }

    // The current plan's percentage: from the product's plan with the same id,
    // else from what the allocation actually saves.
    function currentPercent(alloc, plans) {
      var id = String(alloc.selling_plan.id);
      var match = null;
      plans.forEach(function (p) { if (!match && String(p.id) === id) match = p; });
      var pct = match ? planPercent(match) : 0;
      if (!pct && alloc.compare_at_price > 0 && alloc.price < alloc.compare_at_price) {
        pct = Math.round((alloc.compare_at_price - alloc.price) / alloc.compare_at_price * 100);
      }
      return pct;
    }

    // "spar 10 %", or "spar opptil 15 %" when the plans differ.
    function saveText(plans) {
      var min = Infinity, max = 0;
      plans.forEach(function (p) {
        var v = planPercent(p);
        if (v < min) min = v;
        if (v > max) max = v;
      });
      if (!max) return '';
      return (min === max ? 'spar ' : 'spar opptil ') + max + ' %';
    }

    // A plan change in flight: every plan select stays disabled until it ends,
    // also in lines redrawn meanwhile.
    var planBusy = false;
    function setPlansDisabled(on) {
      planBusy = on;
      $$('[data-tind-cart-plan]', drawer).forEach(function (s) { s.disabled = on; });
    }

    // Focus and notices carried across a redraw. A line is found again by its
    // variant id and position (its key changes with the plan).
    var focusWanted = null;   // { variantId, line, renderId }
    var noticeWanted = null;  // { variantId, line, text, renderId }
    function sameLine(want, li) {
      return want && String(want.variantId) === li.dataset.variantId &&
        (String(want.line) === li.dataset.line ||
         !$$('[data-tind-cart-item]', itemsEl).some(function (o) {
           return o.dataset.line === String(want.line) && o.dataset.variantId === String(want.variantId);
         }));
    }
    function lineRef(li) {
      return { variantId: li.dataset.variantId, line: li.dataset.line };
    }

    function fillSubscription(li, item, info, renderId) {
      var box = li.querySelector('[data-tind-cart-sub]');
      if (!box) return;
      var alloc = item.selling_plan_allocation;
      var current = alloc && alloc.selling_plan;
      var plans = info.plans.slice();
      if (current && !plans.some(function (p) { return String(p.id) === String(current.id); })) plans.push(current);

      // A small toggle: «↻ Abonnér · spar 10 %» turns the line into a
      // subscription on the first plan; «✓ Abonnement» turns it back into a
      // one-time buy. With more than one plan the intervals show as small
      // chips while it is on. A required plan shows as a plain tag.
      var pct = current ? currentPercent(alloc, info.plans) : 0;
      var saveLabel = current ? (pct ? 'spar ' + pct + ' %' : '') : saveText(plans);
      var toggleText = (current ? '<span aria-hidden="true">✓</span> Abonnement' : '<span aria-hidden="true">↻</span> Abonnér') +
        (saveLabel ? ' <span class="tind-cart-drawer__sub-save">· ' + escapeHtml(saveLabel) + '</span>' : '');
      var toggle = current && info.required
        ? '<span class="tind-cart-drawer__sub-toggle is-on">' + toggleText + '</span>'
        : '<button type="button" class="tind-cart-drawer__sub-toggle' + (current ? ' is-on' : '') + '"' +
          ' data-tind-cart-plan data-which="toggle" data-plan="' + escapeHtml(current ? '' : plans[0].id) + '"' +
          ' aria-pressed="' + (current ? 'true' : 'false') + '">' + toggleText + '</button>';
      var extra = '';
      if (current && plans.length > 1) {
        extra = '<div class="tind-cart-drawer__sub-plans" role="group" aria-label="Levering">' +
          plans.map(function (p) {
            var on = String(p.id) === String(current.id);
            return '<button type="button" class="tind-cart-drawer__sub-plan' + (on ? ' is-on' : '') + '"' +
              ' data-tind-cart-plan data-which="' + escapeHtml(p.id) + '" data-plan="' + escapeHtml(p.id) + '"' +
              ' aria-pressed="' + (on ? 'true' : 'false') + '">' + escapeHtml(p.name) + '</button>';
          }).join('') + '</div>';
      } else if (current) {
        extra = '<span class="tind-cart-drawer__sub-name">' + escapeHtml(current.name) + '</span>';
      }

      // The message element is there (empty, not hidden) before it is ever
      // filled, so screen readers pick up the text when it arrives.
      box.dataset.current = current ? String(current.id) : '';
      box.innerHTML = '<div class="tind-cart-drawer__sub-row">' + toggle + extra + '</div>' +
        '<p class="tind-cart-drawer__sub-msg" data-tind-cart-sub-msg role="status"></p>';
      $$('[data-tind-cart-plan]', box).forEach(function (b) { b.disabled = planBusy; });
      box.hidden = false;

      if (focusWanted && focusWanted.renderId === renderId && sameLine(focusWanted, li)) {
        var target = box.querySelector('[data-which="' + focusWanted.which + '"]') ||
          box.querySelector('[data-tind-cart-plan]');
        focusWanted = null;
        if (target) target.focus();
      }
      if (noticeWanted && noticeWanted.renderId === renderId && sameLine(noticeWanted, li)) {
        var text = noticeWanted.text;
        noticeWanted = null;
        var msg = box.querySelector('[data-tind-cart-sub-msg]');
        setTimeout(function () { msg.textContent = text; }, 50);
      }
    }

    function renderSubscriptions(items, renderId) {
      if (!itemsEl || !document.body.contains(drawer)) return;
      $$('[data-tind-cart-item]', itemsEl).forEach(function (li) {
        if (!li.querySelector('[data-tind-cart-sub]')) return;
        var item = items[parseInt(li.dataset.line, 10) - 1];
        var handle = item && productHandle(item);
        if (!handle) return;
        loadPlans(handle).then(function (info) {
          // Skip when a newer render has replaced this line meanwhile.
          if (renderId !== renderSeq || !li.parentNode) return;
          // Without the product's plans, a subscription line still shows its
          // own plan (and «Kjøp én gang») from the cart data.
          var alloc = item.selling_plan_allocation;
          if (!info && alloc && alloc.selling_plan) info = { plans: [], required: false };
          if (info) fillSubscription(li, item, info, renderId);
        });
      });
    }

    // One polite live region in the drawer, shared with Tind Offers (which
    // looks for .tind-sr-status as a child of the drawer). Made at start: a
    // region made and filled at once is not read out.
    function liveRegion() {
      var region = $('.tind-sr-status', drawer);
      if (region) return region;
      region = document.createElement('p');
      region.className = 'tind-sr-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      drawer.appendChild(region);
      return region;
    }
    liveRegion();
    // Cleared, then set a moment later, so the same text twice is read again.
    function announce(text) {
      var region = liveRegion();
      region.textContent = '';
      setTimeout(function () { region.textContent = text; }, 30);
    }

    // The cart as it is now, and the 0-based index of the line with this key
    // in it (-1 when gone). Line numbers from the last render can be stale: a
    // gift or another app's write may have moved the line since.
    function freshLine(key) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          var items = (state && state.items) || [];
          var idx = -1;
          items.forEach(function (it, i) { if (idx < 0 && it.key === key) idx = i; });
          return { state: state, idx: idx, item: items[idx] };
        });
    }

    var PLAN_ERROR = 'Vi fikk ikke endret abonnementet. Prøv igjen om litt.';

    // Set or remove a line's selling plan. Shopify Ajax Cart API docs,
    // POST /cart/change.js, `selling_plan`: a selling plan id sets one;
    // "null or an empty string" removes any selling plan from the line item.
    // We send null, as in the docs' example. The docs also say only the `line`
    // property (1-based index) can identify the line item when changing its
    // selling plan, not `id`/key, and that `quantity` should always be sent
    // (it defaults to 1). So the line is looked up by key in a fresh /cart.js.
    function changePlan(button) {
      var li = button.closest('[data-tind-cart-item]');
      var box = button.closest('[data-tind-cart-sub]');
      if (!li || !box || planBusy) return;
      var key = li.dataset.key;
      var value = button.dataset.plan || '';
      var previous = box.dataset.current || '';
      if (value === previous) return;
      var ref = lineRef(li);
      var which = button.dataset.which;
      var hadFocus = document.activeElement === button;
      var msg = li.querySelector('[data-tind-cart-sub-msg]');
      if (msg) msg.textContent = '';
      var chosenName = button.classList.contains('tind-cart-drawer__sub-plan')
        ? button.textContent
        : 'abonnement';

      function fail() {
        setPlansDisabled(false);
        if (msg) msg.textContent = PLAN_ERROR;
        if (hadFocus) button.focus();
      }

      setPlansDisabled(true);
      return freshLine(key)
        .then(function (fresh) {
          if (fresh.idx < 0) {
            // The line changed elsewhere: redraw, and say so on the line found
            // again by variant and position.
            setPlansDisabled(false);
            noticeWanted = { variantId: ref.variantId, line: ref.line, text: PLAN_ERROR };
            if (hadFocus) focusWanted = { variantId: ref.variantId, line: ref.line, which: which };
            render(fresh.state);
            announce(PLAN_ERROR);
            return;
          }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: fresh.idx + 1, quantity: fresh.item.quantity, selling_plan: value ? Number(value) : null })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('change.js ' + r.status);
              return r.json();
            })
            .then(function (state) {
              planBusy = false;
              if (hadFocus) focusWanted = { variantId: ref.variantId, line: fresh.idx + 1, which: which };
              render(state);
              announce(value ? (previous ? 'Levering endret: ' + chosenName : 'Gjort om til abonnement') : 'Endret til kjøp én gang');
            }, fail);
        })
        .catch(fail);
    }

    drawer.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-tind-cart-plan]');
      if (button) changePlan(button);
    });

    function renderShippingBar(state) {
      if (!freeShippingEnabled || !shipBar || freeShippingThreshold <= 0) return;
      var subtotal = state.items_subtotal_price != null ? state.items_subtotal_price : state.total_price;
      var remaining = freeShippingThreshold - subtotal;
      var pct = Math.min(100, Math.max(0, (subtotal / freeShippingThreshold) * 100));
      if (shipBarFill) shipBarFill.style.width = pct.toFixed(1) + '%';
      if (shipBarText) {
        if (remaining <= 0) {
          shipBarText.textContent = unlockedText;
          shipBar.classList.add('is-unlocked');
        } else {
          shipBarText.textContent = progressTextTpl.replace('{{remaining}}', formatMoney(remaining));
          shipBar.classList.remove('is-unlocked');
        }
      }
    }

    function renderCartLevelDiscounts(state) {
      if (!discountsEl) return;
      var apps = state.cart_level_discount_applications || [];
      var lineLevelTotal = 0;
      (state.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) { lineLevelTotal += a.amount || 0; });
      });
      // Hide if no discounts at all
      if (apps.length === 0 && lineLevelTotal === 0) {
        discountsEl.hidden = true;
        discountsEl.innerHTML = '';
        return;
      }
      discountsEl.hidden = false;
      var html = '';
      // Roll line-level into a single row only if there are no cart-level discounts surfacing names
      if (lineLevelTotal > 0 && apps.length === 0) {
        html += '<li class="tind-cart-drawer__row tind-cart-drawer__row--discount">' +
                '<span>Produktrabatter</span>' +
                '<span>−' + formatMoney(lineLevelTotal) + '</span>' +
                '</li>';
      }
      apps.forEach(function (d) {
        html += '<li class="tind-cart-drawer__row tind-cart-drawer__row--discount">' +
                '<span>' + escapeHtml(d.title || '') + '</span>' +
                '<span>−' + formatMoney(d.total_allocated_amount || 0) + '</span>' +
                '</li>';
      });
      discountsEl.innerHTML = html;
    }

    // A bundle member is hidden when it's a zero-priced placeholder (the kit
    // "parent"/grouping line); its price lives on a sibling line in the group.
    function isHiddenBundleLine(item, inBundle) {
      return inBundle && (item.final_line_price | 0) === 0;
    }

    var renderSeq = 0;
    function render(state) {
      if (!state) return;
      var renderId = ++renderSeq;
      var items = state.items || [];
      // Keep focus on a plan select across the redraw; drop wants an earlier
      // render could not place.
      if (focusWanted && focusWanted.renderId != null) focusWanted = null;
      if (noticeWanted && noticeWanted.renderId != null) noticeWanted = null;
      var active = document.activeElement;
      if (!focusWanted && itemsEl && active && active.matches && active.matches('[data-tind-cart-plan]') && itemsEl.contains(active)) {
        focusWanted = lineRef(active.closest('[data-tind-cart-item]'));
        focusWanted.which = active.dataset.which;
      }
      if (focusWanted) focusWanted.renderId = renderId;
      if (noticeWanted) noticeWanted.renderId = renderId;
      var groups = computeBundleGroups(items);

      // Count only the lines we actually show, so zero-priced bundle
      // placeholders don't inflate the "X varer" label or header dot.
      var visibleCount = 0;
      items.forEach(function (item, i) {
        if (!isHiddenBundleLine(item, groups.groupOf[i] != null)) visibleCount += item.quantity;
      });

      if (countEl) {
        var label = visibleCount === 1 ? 'vare' : 'varer';
        countEl.textContent = visibleCount + ' ' + label;
      }
      if (state.item_count === 0) {
        if (emptyEl) emptyEl.hidden = false;
        if (itemsEl) itemsEl.hidden = true;
        if (footEl) footEl.hidden = true;
        if (shipBar) shipBar.hidden = true;
      } else {
        if (emptyEl) emptyEl.hidden = true;
        if (itemsEl) {
          itemsEl.hidden = false;
          itemsEl.innerHTML = '';
          items.forEach(function (item, i) {
            var gid = groups.groupOf[i];
            var inBundle = gid != null;
            if (isHiddenBundleLine(item, inBundle)) return;
            itemsEl.appendChild(renderItem(item, i, inBundle ? groups.keysByGroup[gid] : null));
          });
          renderSubscriptions(items, renderId);
        }
        if (footEl) footEl.hidden = false;
        if (shipBar && freeShippingEnabled && freeShippingThreshold > 0) shipBar.hidden = false;
        if (subtotalEl) subtotalEl.textContent = formatMoney(state.original_total_price != null ? state.original_total_price : state.total_price);
        if (totalEl) totalEl.textContent = formatMoney(state.total_price);
        renderCartLevelDiscounts(state);
        renderShippingBar(state);
      }
      // Update all header cart dots (brand bar + pinned navbar)
      $$('.tind-header__cartdot').forEach(function (dotEl) {
        dotEl.textContent = String(visibleCount);
        dotEl.style.display = visibleCount > 0 ? '' : 'none';
      });
      // Lets apps (Tind Offers) fill the drawer slots after each render.
      // v = version of the Tind cart contract (slots + this event).
      document.dispatchEvent(new CustomEvent('tind:cart-rendered', { detail: { state: state, v: 1 } }));
    }

    function refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (state) { render(state); return state; });
    }

    function changeLine(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    // Remove every line of a bundle at once (by line-item key) so removing a kit
    // doesn't leave its sibling/placeholder lines orphaned in the cart.
    function removeKeys(keys) {
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    // Steppers and remove: the line is found by key in a fresh /cart.js, so a
    // line that moved since the last render (a gift added above it, another
    // app's write) is still the one changed. Gone: just redraw.
    function changeByKey(key, dir) {
      return freshLine(key).then(function (fresh) {
        if (fresh.idx < 0) { render(fresh.state); return; }
        var qty = dir == null ? 0 : Math.max(0, fresh.item.quantity + dir);
        return changeLine(fresh.idx + 1, qty);
      });
    }

    drawer.addEventListener('click', function (e) {
      var step = e.target.closest && e.target.closest('[data-tind-cart-step]');
      var remove = e.target.closest && e.target.closest('[data-tind-cart-remove]');
      if (remove && remove.dataset.keys) {
        try { removeKeys(JSON.parse(remove.dataset.keys)); } catch (err) {}
        return;
      }
      var target = step || remove;
      var li = target && target.closest('[data-tind-cart-item]');
      if (!li) return;
      changeByKey(li.dataset.key, step ? parseInt(step.dataset.tindCartStep, 10) : null);
    });

    // Initial sync so progress bar + counts reflect current cart state on every page
    refresh();

    // Listen for ajaxProduct:added (legacy) AND cart:updated (modern bundle blocks)
    document.addEventListener('ajaxProduct:added', function () {
      refresh().then(open);
    });
    document.addEventListener('cart:updated', function () {
      refresh();
    });

    // A bundle discount is applied a moment AFTER the items are added, so the
    // first /cart.js can land before it shows. Re-sync /cart.js until a discount
    // appears — independent of bundle detection, since the only reliable signal
    // is the discount actually arriving in the cart. Gated to multi-line / tagged
    // carts so plain single-product adds don't poll needlessly.
    function couldBeDiscounted(state) {
      var items = (state && state.items) || [];
      if (items.length >= 2) return true;
      return items.some(function (it) {
        return it.properties && Object.keys(it.properties).length > 0;
      });
    }
    function pollForBundleDiscounts(state, tries) {
      if (cartHasDiscount(state) || tries <= 0 || !couldBeDiscounted(state)) return;
      setTimeout(function () {
        refresh().then(function (next) { pollForBundleDiscounts(next, tries - 1); });
      }, 800);
    }

    // React to observed cart writes (theme, FastBundle, any cart app). Debounced
    // so a bundle that fires several component requests refreshes once.
    function isOwnWrite() {
      var S = window.TindStorefront;
      try { return !!(S && typeof S.isOwnWrite === 'function' && S.isOwnWrite()); } catch (err) { return false; }
    }
    var mutateTimer = null;
    var pendingOpen = false;
    document.addEventListener('tind:cart-mutated', function (e) {
      // The app's own writes (Tind Offers adding a gift) refresh the drawer
      // but never pop it open.
      if (e.detail && e.detail.opened && !isOwnWrite()) pendingOpen = true;
      if (mutateTimer) clearTimeout(mutateTimer);
      mutateTimer = setTimeout(function () {
        mutateTimer = null;
        var shouldOpen = pendingOpen;
        pendingOpen = false;
        refresh().then(function (state) {
          if (shouldOpen) {
            open();
            pollForBundleDiscounts(state, 10); // ~8s window for the discount to land
          }
        });
      }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
